module.exports = __webpack_public_path__ + "img/calendar.686079f2.png";